/**
 * The cost-model agent returns `{ output: [{ result: {...} }] }`, while the views read
 * `data.output.foreach[].answer`. This maps the agent shape onto the shape the views expect
 * and leaves already-shaped payloads untouched.
 */
const findAgentOutput = (payload: any): any[] | null => {
  const candidates = [payload?.output, payload?.data?.output, payload?.data?.data?.output];
  return candidates.find((c) => Array.isArray(c)) ?? null;
};

export const normalizeCostModelResult = <T extends Record<string, any> | null | undefined>(result: T): T => {
  if (!result || typeof result !== "object") return result;
  if (Array.isArray((result as any)?.data?.output?.foreach)) return result;

  const agentOutput = findAgentOutput(result);
  if (!agentOutput) return result;

  const foreach = agentOutput
    .map((item) => ({ ...item, answer: item?.result ?? item?.answer }))
    .filter((item) => item.answer && typeof item.answer === "object");
  if (foreach.length === 0) return result;

  const data = (result as any).data && typeof (result as any).data === "object" ? (result as any).data : {};
  return {
    ...result,
    data: { ...data, output: { foreach } },
  } as T;
};
